export default {
    name: 'Variance & Attribution',
    data: {
        "id": "v1",
        "type": "Variance",
        "title": "Gas vs Wind Attribution",
        "config": {
            "target": {
                "id": "t1",
                "type": "Single",
                "title": "TTF Price Spread",
                "config": {
                    "type_id": "price",
                    "market_name": "TTF Front Month",
                    "operator": "vwap"
                }
            },
            "parameters": [
                {
                    "id": "p1",
                    "type": "Single",
                    "title": "Gas Linepack",
                    "config": {
                        "type_id": "linepack",
                        "hub_id": 14,
                        "hour": "06"
                    }
                },
                {
                    "id": "p2",
                    "type": "Single",
                    "title": "Total Wind",
                    "config": {
                        "type_id": "production",
                        "fuel_id": "wind"
                    }
                }
            ]
        }
    }
}
